import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

// Générer un ID de session unique basé sur le timestamp et un hash simple
const generateSessionId = () => {
  const timestamp = Date.now().toString();
  const randomStr = Math.random().toString(36).substring(2, 15);
  return `${timestamp}-${randomStr}`;
};

// Obtenir ou créer un ID de session
const getSessionId = () => {
  const storageKey = 'visitor_session_id';
  let sessionId = sessionStorage.getItem(storageKey);
  
  if (!sessionId) {
    sessionId = generateSessionId();
    sessionStorage.setItem(storageKey, sessionId);
  }
  
  return sessionId;
};

// Vérifier si c'est un visiteur récurrent
const isReturningVisitor = () => {
  const storageKey = 'has_visited_before';
  const hasVisited = localStorage.getItem(storageKey);
  
  if (!hasVisited) {
    localStorage.setItem(storageKey, 'true');
    return false;
  }
  
  return true;
};

// Hook pour tracker les visiteurs
export const useVisitorTracking = () => {
  useEffect(() => {
    const trackVisitor = async () => {
      try {
        // Obtenir les informations du visiteur
        const sessionId = getSessionId();
        const isReturning = isReturningVisitor();
        const userAgent = navigator.userAgent;
        const referrer = document.referrer || null;
        const pagePath = window.location.pathname;
        
        // Utiliser la fonction edge sécurisée pour enregistrer la visite
        const { error } = await supabase.functions.invoke('track-visitor', {
          body: {
            userAgent,
            referrer,
            pagePath,
            isReturning,
            sessionId,
          },
        });

        if (error) {
          console.error('Erreur lors de l\'enregistrement de la visite:', error);
        }

      } catch (error) {
        console.error('Erreur lors du tracking:', error);
      }
    };

    // Tracker seulement une fois par session
    const hasTrackedThisSession = sessionStorage.getItem('tracked_this_session');
    if (!hasTrackedThisSession) {
      trackVisitor();
      sessionStorage.setItem('tracked_this_session', 'true');
    }

  }, []);
};

export default useVisitorTracking;